import { render, staticRenderFns } from "./ExpenseBodyHeader.vue?vue&type=template&id=14036255&scoped=true&"
import script from "./ExpenseBodyHeader.vue?vue&type=script&lang=js&"
export * from "./ExpenseBodyHeader.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseBodyHeader.vue?vue&type=style&index=0&id=14036255&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14036255",
  null
  
)

export default component.exports